import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  Typography,
  Paper,
  Divider
} from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    height: 'auto'
  },
  content: {
    textAlign: 'center',
    padding: '40px 25px 1.5rem 25px'
  },
  divider: {
    marginTop: '1rem',
    marginBottom: '1.5rem'
  },
  pending: {
    marginBottom: '20px'
  }
}))

const EmailVerified = ({userName}) => {
  const classes = useStyles()

  return(
    <Paper elevation={3} className={classes.container}>
      <div className={classes.content}>
        <Typography variant='h4'>
          Welcome {userName}!
        </Typography>
        <Divider className={classes.divider}/>
        <div className={classes.pending}>
          <Typography variant='subtitle1' gutterBottom>
            Thank you for registering for CEBA InterConnect.
            Your account is pending authorization.
          </Typography>
          <Typography variant='subtitle2'>
            <strong>You will be notified via email once your account has been approved.</strong>
          </Typography>
        </div>
      </div>
    </Paper>
  )
}

export default EmailVerified
